import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Card } from 'primereact/card';
import { Message } from 'primereact/message';
import TransactionHistoryTable from '../TransactionHistoryTable';
import './style.scss';

class DataIntegrityReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            globalAcademicYear: localStorage.getItem('userAcademicYear')
        };
    }

    componentDidMount() {
        window.addEventListener('storage', this.handleStorageChange);
        window.addEventListener('academicYearChanged', this.handleCustomAyChange);

        const currentAy = localStorage.getItem('userAcademicYear');
        if (currentAy) {
            this.setState({ globalAcademicYear: currentAy });
        }
    }

    componentWillUnmount() {
        window.removeEventListener('storage', this.handleStorageChange);
        window.removeEventListener('academicYearChanged', this.handleCustomAyChange);
    }

    handleStorageChange = (e) => {
        if (e.key === 'userAcademicYear') {
            this.setState({ globalAcademicYear: e.newValue });
        }
    };

    handleCustomAyChange = (e) => {
        const { academicYearId } = e.detail;
        this.setState({ globalAcademicYear: academicYearId });
    }

    render() {
        const { globalAcademicYear } = this.state;

        return (
            <div className="data-integrity-report">
                <Card title="📊 Data Integrity Report" className="p-mb-3">
                    <div className="report-description">
                        <p>
                            This report shows the complete history of all bulk fee data uploads, 
                            including validation results, success/failure counts, and detailed error logs.
                        </p>
                        <p>
                            Use this to monitor data quality, track upload issues, and download 
                            error sheets for records that failed validation or processing.
                        </p>
                    </div>
                    
                    {!globalAcademicYear && (
                        <div className="p-mt-2">
                            <Message 
                                severity="warn" 
                                text="Academic Year not selected. Transaction history will show uploads across all years." 
                            />
                        </div>
                    )}
                </Card>

                <Card title="Upload Transaction History" className="history-card">
                    <TransactionHistoryTable 
                        {...this.props}
                        showCard={false}
                        showToast={true}
                    />
                </Card>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    orgId: state.currentUserPerms && state.currentUserPerms.userInfo ? state.currentUserPerms.userInfo.orgId : null,
    academicYearList: state.admissions && state.admissions.academicYearList ? state.admissions.academicYearList : []
});

export default connect(mapStateToProps)(DataIntegrityReport);
